<div class="row">
  <div class="head-component m-b-25">
    <div class="col-10 m-0 p-l-15 p-r-30 br-0 head-component for-fixed-component card">
      <div class="row pl-0 p-r-70 card-body">
        <div class="col-8 p-l-20 pt-2">
          <h5 class="m-0" [routerLink]="['/admin/questionnaires']">
            <span class="head-main-component">Surveys</span>
          </h5>
        </div>
        <div class="col-1 float-right btn btn-sm btn-info" (click)="saveSurvey()" id="btn_save_survey">Save survey</div>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="categories">
  <div class="col-9">
    <div class="row p-l-10 p-r-10">
      <div class="col-12">
        <div class="card m-b-15 base-shadow-list b-0">
          <div class="card-body pb-0">
            <form class="form-material m-t-10 row" [formGroup]="surveyForm">
              <div class="form-group col-12 answer-even-input">
                <input
                  *ngFor="let item of namePropertiesArray; let i = index"
                  [formControlName]="item"
                  class="form-control m-b-10"
                  [id]="item"
                  type="text"
                  [placeholder]="namePlaceholders[i]"
                />
              </div>
              <div class="form-group col-12 answer-even-input">
                <input
                  *ngFor="let item of descriptionPropertiesArray; let i = index"
                  [placeholder]="descriptionPlaceholders[i]"
                  [formControlName]="item"
                  class="form-control m-b-10"
                  [id]="item"
                  type="text"
                />
              </div>
              <div class="form-group col-12 ml-0 answer-even-input">
                <label class="col-12 p-l-0">Estimation of survey completion (optional)</label>
                <input formControlName="duration" class="form-control col-1" [id]="item" type="text" />
                <span> minutes</span>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        class="col-12"
        [sortablejs]="surveyDraggableCategories"
        [sortablejsOptions]="surveyCategoriesSortableOptions"
        style="min-height: 300px; min-width: 800px"
      >
        <div *ngFor="let categoryItem of surveyDraggableCategories">
          <div class="card m-b-15 pt-0 pb-0 base-shadow-list b-0" *ngIf="categoryItem.category">
            <div class="card-header b-tl-tr">
              <i
                class="fa head-icon"
                (click)="showHideCategoryQuestions(categoryItem.category)"
                [ngClass]="categoryItem.category.isHidden ? 'fa-caret-down' : 'fa-caret-up'"
              ></i>
              <i
                class="head-icon mdi mdi-close close-button"
                (click)="removeCategoryFromSurvey(categoryItem.category.id)"
              ></i>
              <h4 class="m-b-0" (click)="showHideCategoryQuestions(categoryItem.category)">
                {{ categoryItem.category.name }}
              </h4>
            </div>
            <div
              [ngClass]="categoryItem.category.isHidden ? 'hiden-category' : ''"
              [sortablejs]="categoryItem.category.questions"
              [sortablejsOptions]="categoryItem.sortableJsOption"
            >
              <div class="card-body question-place" *ngFor="let question of categoryItem.category.questions">
                <app-question-forms-selector
                  [question]="question"
                  [selectedCategoryId]="categoryItem.category.id"
                  [isMandatoryQuestion]="question.isMandatory"
                  (onRemoveQuestionFromSurvey)="removeQuestionFromSurvey($event)"
                  (onQuestionMandatoryChange)="changeQuestionMandatory($event)"
                  [isSurveyQuestion]="true"
                ></app-question-forms-selector>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-3 pl-0 pr-0 questions">
    <div class="for-fixed-component categories-list base-shadow-list b-0">
      <div class="head-template">
        <div>Question categories</div>
      </div>
      <accordion slimScroll width="auto" height="480px" size="5px" alwaysVisible="true">
        <div [sortablejs]="categories" [sortablejsOptions]="menuCategoriesSortableOptions">
          <accordion-group
            [id]="category.id"
            *ngFor="let category of categories; let i = index"
            heading="{{ category.name }}"
          >
            <div class="m-t-10">
              <div class="search-template p-0 m-0">
                <input type="search" value="" class="mb-0" />
                <i class="ti-search"></i>
              </div>
              <div [sortablejs]="category.questions" [sortablejsOptions]="menuCategoryQuestionsSortableOptions[i]">
                <div
                  *ngFor="let question of category.questions"
                  [attr.categoryid]="category.id"
                  class="row mr-0 ml-0 mb-3 mt-3"
                  [id]="question.id"
                >
                  <div class="col-1 pl-0 pr-0">
                    <div [id]="category.id" class="type-question" [ngClass]="getIconType(question.answerType)"></div>
                  </div>
                  <div class="col-11 pl-0 pr-0 lh-1-2">
                    {{ question.name }}
                  </div>
                </div>
              </div>
            </div>
          </accordion-group>
        </div>
      </accordion>
    </div>
  </div>
</div>
